import { render } from "./footer.vue?vue&type=template&id=fbff7edc&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=fbff7edc&scoped=true&lang=scss"

import exportComponent from "F:\\kc\\黄石城发建设内部招投标平台\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbff7edc"]])

export default __exports__